(function () {
  if (customElements.get('hm-timeline-scroll')) return;

  class HmTimelineScroll extends HTMLElement {
    connectedCallback() {
      this.slides = Array.prototype.slice.call(this.querySelectorAll('[data-hm-tl-slide]'));
      this.dots = Array.prototype.slice.call(this.querySelectorAll('[data-hm-tl-dot]'));
      this.pin = this.querySelector('.hm-tl-m__pin');
      this.sticky = this.querySelector('.hm-tl-m__sticky');
      if (!this.pin || !this.sticky || this.slides.length < 2) return;

      this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.desktop = window.matchMedia('(min-width: 750px)');
      this.current = -1;
      this.ticking = false;

      this.onScroll = this.onScroll.bind(this);
      this.onFrame = this.onFrame.bind(this);
      this.onMedia = this.onMedia.bind(this);
      this.lastWidth = window.innerWidth;

      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onMedia, { passive: true });
      window.addEventListener('load', this.onMedia);
      this.reduce.addEventListener('change', this.onMedia);
      this.desktop.addEventListener('change', this.onMedia);
      this.layout();
      this.onScroll();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onMedia);
      window.removeEventListener('load', this.onMedia);
      this.reduce.removeEventListener('change', this.onMedia);
      this.desktop.removeEventListener('change', this.onMedia);
    }

    inactive() {
      return this.desktop.matches || this.reduce.matches || this.classList.contains('hm-tl-m--editor');
    }

    onMedia() {
      var width = window.innerWidth;
      if (width === this.lastWidth && this.pin && this.pin.style.height) return;
      this.lastWidth = width;
      this.layout();
      this.current = -1;
      this.onScroll();
    }

    layout() {
      if (!this.pin || !this.sticky) return;
      if (this.inactive()) {
        this.pin.style.height = '';
        return;
      }
      var stickyH = this.sticky.offsetHeight || 1;
      var step = Math.round(Math.max(280, window.innerHeight * 0.55));
      var extra = Math.max(1, this.slides.length - 1) * step;
      this.pin.style.height = stickyH + extra + 'px';
    }

    onScroll() {
      if (this.ticking) return;
      this.ticking = true;
      window.requestAnimationFrame(this.onFrame);
    }

    syncChrome() {
      var styles = getComputedStyle(document.documentElement);
      var header = parseFloat(styles.getPropertyValue('--header-height')) || 0;
      var announcement = parseFloat(styles.getPropertyValue('--hm-announcement-height')) || 0;
      var next = Math.round(header + announcement);
      if (!next) {
        var chrome = document.querySelector('.hm-chrome');
        next = chrome ? Math.round(chrome.offsetHeight) : 0;
      }
      if (this._chromeTop === next) return;
      this._chromeTop = next;
      this.sticky.style.setProperty('--hm-tl-top', next + 'px');
    }

    onFrame() {
      this.ticking = false;
      if (this.inactive()) {
        this.setSlide(0, true);
        return;
      }

      this.syncChrome();

      var pinRect = this.pin.getBoundingClientRect();
      var stickyRect = this.sticky.getBoundingClientRect();
      var range = Math.max(1, this.pin.offsetHeight - this.sticky.offsetHeight);
      var scrolled = stickyRect.top - pinRect.top;
      var p = scrolled / range;
      if (p < 0) p = 0;
      if (p > 1) p = 1;

      this.setSlide(Math.round(p * (this.slides.length - 1)));
    }

    setSlide(index, silent) {
      if (index === this.current) return;
      this.current = index;
      this.slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === index);
        slide.setAttribute('aria-hidden', i === index ? 'false' : 'true');
      });
      this.dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
      if (!silent) this.setAttribute('data-active', String(index));
    }
  }

  customElements.define('hm-timeline-scroll', HmTimelineScroll);
})();
